export default {
	"odin": {
		Component: require("./odin/Fields/Fields").default,
		fulfillmentCheck: require("./odin/Fields/Fields.fulfillment").default,
	},
	"nordfk-cob": {
		Component: require("./nordfk-cob/Fields/Fields").default,
		fulfillmentCheck: require("./nordfk-cob/Fields/Fields.fulfillment").default,
	},
	"auagfonder": {
		Component: require("./auagfonder/Fields/Fields").default,
		fulfillmentCheck: require("./auagfonder/Fields/Fields.fulfillment").default,
	},
	"alfakraft": {
		Component: require("./alfakraft/Fields/Fields").default,
		fulfillmentCheck: require("./alfakraft/Fields/Fields.fulfillment").default,
	},
	"fair-gds-oppna": {
		Component: require("./fair-gds-oppna/Fields/Fields").default,
		fulfillmentCheck: require("./fair-gds-oppna/Fields/Fields.fulfillment").default,
	}
};


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Questionnaire/partners/index.js